import React, { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import logo from "../../assets/logo.png";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";

const HomeNav = () => {
  const location = useLocation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const isOnContactUs = location.pathname === "/contact-us";
  const isOnPrivacyPolicy = location.pathname === "/privacy-policy";

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
    setIsMobileMenuOpen(false); // Close mobile menu after navigation
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <>
      <nav
        id="nav"
        className="bg-[#FAF8F7] h-[72px] flex justify-between items-center px-4 md:px-12 font-tahoma relative z-50"
      >
        <NavLink
          to={"/"}
          alt="Twokey"
          className="flex items-center gap-2 md:gap-3 transition-all duration-300 hover:opacity-80 active:scale-95"
        >
          <img
            src={logo}
            alt="Twokey"
            className="h-8 md:h-10 lg:h-12 w-auto object-contain"
          />
          <span className="text-xl md:text-2xl lg:text-3xl font-bold leading-tight text-[#273720]">
            Twokey
          </span>
        </NavLink>

        {/* Desktop Navigation Links */}
        {isOnContactUs || isOnPrivacyPolicy ? (
          <span className="hidden lg:flex gap-3 py-2">
            <a href="/#pricing" className="px-5 py-2.5 bg-[#C8C6FF] hover:bg-[#B5B2FF] text-[#131149] font-medium rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-0.5">
              Pricing
            </a>
            <a href="/#product" className="px-5 py-2.5 bg-[#C8C6FF] hover:bg-[#B5B2FF] text-[#131149] font-medium rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-0.5">
              Product
            </a>
            <a href="/#about" className="px-5 py-2.5 bg-[#C8C6FF] hover:bg-[#B5B2FF] text-[#131149] font-medium rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-0.5">
              About Us
            </a>
            {!isOnContactUs && (
              <Link to="/contact-us" className="px-5 py-2.5 bg-[#C8C6FF] hover:bg-[#B5B2FF] text-[#131149] font-medium rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-0.5">
                Contact Us
              </Link>
            )}
            {!isOnPrivacyPolicy && (
              <Link to="/privacy-policy" className="px-5 py-2.5 bg-[#C8C6FF] hover:bg-[#B5B2FF] text-[#131149] font-medium rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-0.5">
                Privacy Policy
              </Link>
            )}
          </span>
        ) : (
          <span className="hidden lg:flex gap-3 py-2">
            <button
              onClick={() => scrollToSection("pricing")}
              className="px-5 py-2.5 bg-[#C8C6FF] hover:bg-[#B5B2FF] text-[#131149] font-medium rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-0.5"
            >
              Pricing
            </button>

            <button
              onClick={() => scrollToSection("product")}
              className="px-5 py-2.5 bg-[#C8C6FF] hover:bg-[#B5B2FF] text-[#131149] font-medium rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-0.5"
            >
              Product
            </button>

            <button
              onClick={() => scrollToSection("about")}
              className="px-5 py-2.5 bg-[#C8C6FF] hover:bg-[#B5B2FF] text-[#131149] font-medium rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-0.5"
            >
              About Us
            </button>

            <Link
              to="/privacy-policy"
              className="px-5 py-2.5 bg-[#C8C6FF] hover:bg-[#B5B2FF] text-[#131149] font-medium rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-0.5"
            >
              Privacy Policy
            </Link>
          </span>
        )}

        {/* Desktop Auth Buttons */}
        <span className="hidden md:flex gap-3 items-center">
          <Link
            to="/login"
            className="px-4 py-2.5 text-[#131149] font-medium rounded-xl hover:bg-white/60 transition-all duration-200"
          >
            Sign in
          </Link>
          <Link
            to="/contact-us"
            className="bg-[#C8C6FF] hover:bg-[#B5B2FF] border-2 border-[#131149] rounded-xl py-2.5 px-5 text-sm font-semibold text-[#131149] shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-0.5"
          >
            Contact Us
          </Link>
        </span>

        {/* Mobile Hamburger Menu Button */}
        <button
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          className="md:hidden p-2 rounded-lg hover:bg-white/60 transition-all duration-200"
          aria-label="Toggle menu"
        >
          {isMobileMenuOpen ? (
            <CloseIcon className="text-[#131149] text-3xl" />
          ) : (
            <MenuIcon className="text-[#131149] text-3xl" />
          )}
        </button>
      </nav>

      {/* Mobile Menu */}
      <div
        className={`md:hidden fixed top-[72px] left-0 w-full bg-[#FAF8F7] shadow-2xl transition-all duration-300 ease-in-out z-40 ${isMobileMenuOpen
            ? "opacity-100 translate-y-0 visible"
            : "opacity-0 -translate-y-4 invisible"
          }`}
      >
        <div className="flex flex-col px-4 py-6 space-y-4">
          {/* Mobile Navigation Links */}
          {isOnContactUs || isOnPrivacyPolicy ? (
            <>
              <a
                href="/#pricing"
                onClick={closeMobileMenu}
                className="w-full px-5 py-3 bg-[#C8C6FF] hover:bg-[#B5B2FF] text-[#131149] font-medium rounded-xl shadow-lg text-center transition-all duration-200 block"
              >
                Pricing
              </a>
              <a
                href="/#product"
                onClick={closeMobileMenu}
                className="w-full px-5 py-3 bg-[#C8C6FF] hover:bg-[#B5B2FF] text-[#131149] font-medium rounded-xl shadow-lg text-center transition-all duration-200 block"
              >
                Product
              </a>
              <a
                href="/#about"
                onClick={closeMobileMenu}
                className="w-full px-5 py-3 bg-[#C8C6FF] hover:bg-[#B5B2FF] text-[#131149] font-medium rounded-xl shadow-lg text-center transition-all duration-200 block"
              >
                About Us
              </a>
              {!isOnPrivacyPolicy && (
                <Link
                  to="/privacy-policy"
                  onClick={closeMobileMenu}
                  className="w-full px-5 py-3 bg-[#C8C6FF] hover:bg-[#B5B2FF] text-[#131149] font-medium rounded-xl shadow-lg text-center transition-all duration-200"
                >
                  Privacy Policy
                </Link>
              )}
              {!isOnContactUs && (
                <Link
                  to="/contact-us"
                  onClick={closeMobileMenu}
                  className="w-full px-5 py-3 bg-[#C8C6FF] hover:bg-[#B5B2FF] text-[#131149] font-medium rounded-xl shadow-lg text-center transition-all duration-200"
                >
                  Contact Us
                </Link>
              )}
            </>
          ) : (
            <>
              <button
                onClick={() => scrollToSection("pricing")}
                className="w-full px-5 py-3 bg-[#C8C6FF] hover:bg-[#B5B2FF] text-[#131149] font-medium rounded-xl shadow-lg transition-all duration-200"
              >
                Pricing
              </button>

              <button
                onClick={() => scrollToSection("product")}
                className="w-full px-5 py-3 bg-[#C8C6FF] hover:bg-[#B5B2FF] text-[#131149] font-medium rounded-xl shadow-lg transition-all duration-200"
              >
                Product
              </button>

              <button
                onClick={() => scrollToSection("about")}
                className="w-full px-5 py-3 bg-[#C8C6FF] hover:bg-[#B5B2FF] text-[#131149] font-medium rounded-xl shadow-lg transition-all duration-200"
              >
                About Us
              </button>
              

              <Link
                to="/privacy-policy"
                onClick={closeMobileMenu}
                className="w-full px-5 py-3 bg-[#C8C6FF] hover:bg-[#B5B2FF] text-[#131149] font-medium rounded-xl shadow-lg text-center transition-all duration-200"
              >
                Privacy Policy
              </Link>
            </>
          )}

          {/* Mobile Auth Buttons */}
          <div className="pt-4 border-t border-[#C8C6FF]/30 space-y-3">
            <Link
              to="/login"
              onClick={closeMobileMenu}
              className="block w-full px-5 py-3 text-[#131149] font-medium rounded-xl bg-white/60 hover:bg-white/80 text-center transition-all duration-200"
            >
              Sign in
            </Link>
            <Link
              to="/contact-us"
              onClick={closeMobileMenu}
              className="block w-full bg-[#C8C6FF] hover:bg-[#B5B2FF] border-2 border-[#131149] rounded-xl py-3 px-5 font-semibold text-[#131149] shadow-lg text-center transition-all duration-200"
            >
              Contact Us
            </Link>
          </div>
        </div>
      </div>

      {/* Mobile Menu Overlay */}
      {isMobileMenuOpen && (
        <div
          className="md:hidden fixed inset-0 bg-black/20 z-30 top-[72px]"
          onClick={closeMobileMenu}
        />
      )}
    </>
  );
};

export default HomeNav;
